import React from 'react';


const MainBanner = props => {
    let pageHeader = React.createRef();
    let iconRef = React.createRef();
    console.log(props.logo_position);
    
    
    React.useEffect(() => {
        if (window.innerWidth > 991) {
            const updateScroll = () => {
                let windowScrollTop = window.pageYOffset / 3;
                let windowScrollIcon = props.logo_position.y + (window.pageYOffset / window.innerHeight) * props.logo_position.y * 0.7;
                pageHeader.current.style.transform =
                    "translate3d(0," + windowScrollTop + "px,0)";
                iconRef.current.style.transform = "translate3d(" + props.logo_position.x + "%, " + windowScrollIcon + "%, 0)";
                // "translate3d(-50%," + windowScrollIcon + "px,0)";
            };
            updateScroll();
            window.addEventListener("scroll", updateScroll);
            return function cleanup() {
                window.removeEventListener("scroll", updateScroll);
            };
        }
    });
    return (
        <>
            <div id="home" className="main-banner" ref={pageHeader}>
                <div className="centered" ref={iconRef}>
                    <img className="tbu-white-logo" src={require("../../assets/images/Logo_TBU_transparent.png")} alt="tbu-logo"/>
                    <h1><b>Ingenieurbüro für das Bauwesen</b></h1>
                </div>
                <div className="image-wrapper">
                    <img className="main-banner-background-image" src={props.image} alt="main-banner" />
                </div>
            </div>
        </>
    );
}

export default MainBanner;
